// Static Web Apps uses build-time environment variables.
const INTERNAL_API_CONFIG = {
	BASE_URL: process.env.REACT_APP_API_URL || (
		process.env.NODE_ENV === 'development'
			? 'http://localhost:3001/api'
			: 'https://api.ppc.nsieng.com/api'
	),
	FRONTEND_URL: process.env.REACT_APP_FRONTEND_URL || (
		process.env.NODE_ENV === 'development'
			? 'http://localhost:3000/'
			: 'https://ppc.nsieng.com/'
	),
};

const EXTERNAL_API_CONFIG = {
	BASE_URL: process.env.REACT_APP_EXTERNAL_API_URL || process.env.REACT_APP_API_URL || (
		process.env.NODE_ENV === 'development'
			? 'http://localhost:3001/api'
			: 'https://ppcexternal-hcdecef8cgefgwhd.westcentralus-01.azurewebsites.net/api'
	),
	FRONTEND_URL: process.env.REACT_APP_EXTERNAL_FRONTEND_URL || process.env.REACT_APP_FRONTEND_URL || (
		process.env.NODE_ENV === 'development'
			? 'http://localhost:3000/'
			: 'https://ext.ppc.nsieng.com/'
	),
};

const deploymentTarget = String(process.env.REACT_APP_DEPLOYMENT_TARGET || 'internal').trim().toLowerCase();

const API_CONFIG = deploymentTarget === 'external' ? EXTERNAL_API_CONFIG : INTERNAL_API_CONFIG;

export default API_CONFIG;